import request from "@/utils/oms-request";
import lms_request from "@/utils/request";
import download from "@/utils/oms-download";
//  列表
export const getList = (params: any) =>
  request({
    url: "/payment_voucher",
    method: "get",
    params
  });
// 新建付款单
export const createPayment = (data: any) =>
  request({
    url: "/payment_voucher",
    method: "put",
    data
  });
// 所有状态 /payment_voucher/status
export const getStatus = () =>
  request({
    url: "/payment_voucher/status",
    method: "get"
  });
// 付款类型 /payment_voucher/payment-type
export const getPaymentType = () =>
  request({
    url: "/payment_voucher/payment-type",
    method: "get"
  });
// 添加关联单据
export const addRelation = (id: string, data: any) =>
  request({
    url: `/payment_voucher/${id}/relation-payment-voucher`,
    method: "put",
    data
  });
// 付款
export const payment = (id: string, params: any) =>
  request({
    url: `/payment_voucher/${id}/payment`,
    method: "put",
    params
  });
//  添加其他费用
export const addOtherFee = (id: string, params: any) =>
  request({
    url: `/payment_voucher/${id}/payment-voucher-other-fee`,
    method: "put",
    params
  });
// 作废
export const invalid = (id: string) =>
  request({
    url: `/payment_voucher/${id}/invalid`,
    method: "put"
  });
// 挂起
export const hangUp = (id: string,params:any) =>
  request({
    url: `/payment_voucher/${id}/hang-up`,
    method: "put",
    params
  });
// 取消挂起
export const cancelHangUp = (id: string,) =>
  request({
    url: `/payment_voucher/${id}/cancel-hang-up`,
    method: "put",
  });
// 审核
export const review = (id: string,) =>
  request({
    url: `/payment_voucher/${id}/review`,
    method: "put",
  });
// 查看详情
export const getDetails = (id: string) =>
  request({
    url: `/payment_voucher/${id}/details`,
    method: "get"
  });
// 移除关联单据
export const removeRelation = (id: string) =>
  request({
    url: `/payment_voucher/relation-payment-voucher/${id}`,
    method: "delete",
  });
//移除其他费用
export const removeOtherFee = (id: string) =>
  request({
    url: `/payment_voucher/payment-voucher-other-fee/${id}`,
    method: "delete",
  });
// 下载单据以明细
export const downloadDetails = (id: string) =>
  download({
    responseType: "blob",
    url: `/payment_voucher/${id}/details-excel`,
    method: "get",
  });
// 新建付款单，选择关联单据
export const getRelationOrder = (data) =>
  request({
    url: `/payment_voucher/relation-order`,
    method: "post",
    data
  });
// 关联单据列表
export const getRelationList = (params: any) =>
  request({
    url: `/payment_voucher/associate-documents`,
    method: "get",
    params
  });
// 备注
export const setRemark = (id: string, data: any) =>
  request({
    url: `/payment_voucher/${id}/remark`,
    method: "put",
    data
  });
//关联付款单
export const getRelationPaymentVoucher = (params: any) =>
  request({
    url: `/payment_voucher/relation-payment-voucher`,
    method: "get",
    params
  });

  // /payment_voucher/settlement-period
  // 结算账期
export const putSettlementPeriod = (params: any) =>
  request({
    url: `/payment_voucher/settlement-period`,
    method: "put",
    params
  });

  // /payment_voucher/relation-order
  export const getRelationOrderToList = (data) =>
  request({
    url: `/payment_voucher/relation-order`,
    method: "post",
    data
  });
  // /payment_voucher/{id}/cancel-invalid
  // 取消作废
  export const putCancelInvalid = (id: any) =>
  request({
    url: `/payment_voucher/${id}/cancel-invalid`,
    method: "put"
  });
  // /payment_voucher/{id}/resetting
  // 更新（重置）
  export const putResetting = (id: any) =>
  request({
    url: `/payment_voucher/${id}/resetting`,
    method: "put"
  });

  export const updatePaymentOrder = (params) =>
    request({
      url: `/payment_voucher/resetting`,
      method: "put",
      params
    });
    export const updatePaymentOrderCheck = (params) =>
      request({
        url: `/payment_voucher/hq-packing-list/other-fee-management/check`,
        method: "get",
        params
      });

  // /payment_voucher/account-period-type
  export const getAccountPeriodType = () =>
    request({
      url: `/payment_voucher/account-period-type`,
      method: "get"
    });

  // 付款单详情删除关联索赔
export const deleteRelationClaim = (params) =>
    request({
        url: `/payment_voucher/relation-claim`,
        method: "delete",
        params
    });